module.exports = __webpack_public_path__ + "static/media/sendAnnouncement.a2e44855.svg";